import NavBar from './NavBar.vue'
import FooterBar from './FooterBar.vue'
// import Sidebar from './Sidebar.vue'
export {
    NavBar,
    FooterBar
    // Sidebar
}



// WEBPACK FOOTER //
// ./src/components/layout/index.js